<script setup>
import { useConfigStore } from "@core/stores/config";
import { switchToVerticalNavOnLtOverlayNavBreakpoint } from "@layouts/utils";

const DefaultLayoutWithHorizontalNav = defineAsyncComponent(() =>
  import("./components/DefaultLayoutWithHorizontalNav.vue")
);
const DefaultLayoutWithVerticalNav = defineAsyncComponent(() =>
  import("./components/DefaultLayoutWithVerticalNav.vue")
);
const configStore = useConfigStore();

// ℹ️ This will switch to vertical nav when define breakpoint is reached when in horizontal nav layout

// Remove below composable usage if you are not using horizontal nav layout in your app
switchToVerticalNavOnLtOverlayNavBreakpoint();

const { layoutAttrs, injectSkinClasses } = useSkins();

injectSkinClasses();

const route = useRoute();
const router = useRouter();

console.warn = () => {};
</script>

<template>
  <div>
    <Component :is="DefaultLayoutWithHorizontalNav" v-bind="layoutAttrs" />
  </div>
</template>

<style lang="scss">
// As we are using `layouts` plugin we need its styles to be imported
@use "@layouts/styles/default-layout";
</style>
